import { render, staticRenderFns } from "./NccToolbarIcon.vue?vue&type=template&id=586bf068&scoped=true&"
import script from "./NccToolbarIcon.vue?vue&type=script&lang=js&"
export * from "./NccToolbarIcon.vue?vue&type=script&lang=js&"
import style0 from "./NccToolbarIcon.vue?vue&type=style&index=0&id=586bf068&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586bf068",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/staging.newcitycatechismus.nl/httpdocs/web/app/themes/wp-subsite-theme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('586bf068')) {
      api.createRecord('586bf068', component.options)
    } else {
      api.reload('586bf068', component.options)
    }
    module.hot.accept("./NccToolbarIcon.vue?vue&type=template&id=586bf068&scoped=true&", function () {
      api.rerender('586bf068', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/components/QNA/NccToolbarIcon.vue"
export default component.exports